import constants from "constants";

const {
  ADD_ERRORS,
  API_ERROR_SAGA,
  ERROR_TYPE_LOGIN_ERROR,
  CLEAN_ERRORS,
  ERROR_TYPE_REQUEST,
  VALIDATE_ERROR_SAGA,
  CURRENT_WEBINARS,
  UPCOMING_WEBINARS,
  PREVIOUS_WEBINARS,
  LOAD_WEBINARS_SAGA,
  SUBSCRIBE_WEBINAR_SAGA,
  UNSUBSCRIBE_WEBINAR_SAGA,
  LOAD_SUBSCRIPTIONS_SAGA,
  LOAD_USERS_WEBINARS_SAGA,
  LOAD_VIMEO_VIDEO_DATA_SAGA,
  ADD_VIMEO_VIDEO_DATA,
  LOAD_WEBINAR_SAGA,
  LOAD_ADMIN_WEBINAR_SAGA,
  JOIN_WEBINAR_SAGA,
  CHECK_ANSWERS_SAGA,
  SHOW_DASHBOARD_MODAL_SAGA,
  UPDATE_MODAL_DATA
} = constants;

export const addErrors = (requestType, errors) => {
  return {
    type: ADD_ERRORS,
    errors: errors,
    requestType: requestType
  };
};

export const cleanErrors = requestType => {
  return {
    type: CLEAN_ERRORS,
    requestType: requestType
  };
};

export const addRequestError = response => {
  return {
    type: API_ERROR_SAGA,
    requestType: ERROR_TYPE_REQUEST,
    response
  };
};

export const addErrorsSaga = (requestType, response) => ({
  type: API_ERROR_SAGA,
  requestType,
  response
});

export const addValidateError = (requestType, errors) => ({
  type: VALIDATE_ERROR_SAGA,
  requestType,
  errors
});

export const loadWebinarsSaga = (webinarType, page, params = {}) => ({
  type: LOAD_WEBINARS_SAGA,
  webinarType,
  page,
  params
});

export const loadWebinarSaga = (
  id,
  temp = false,
  loadVideo = false,
  trackView = false
) => ({
  type: LOAD_WEBINAR_SAGA,
  temp,
  loadVideo,
  id,
  trackView
});

export const loadAdminWebinarSaga = (
  id,
  temp = false,
  loadVideo = false,
  trackView = false
) => ({
  type: LOAD_ADMIN_WEBINAR_SAGA,
  temp,
  loadVideo,
  id,
  trackView
});

export const checkAnswersSaga = (answers, webinarId) => ({
  type: CHECK_ANSWERS_SAGA,
  answers,
  webinarId
});

export const loadCurrentWebinarsSaga = (page, params = {}) =>
  loadWebinarsSaga(CURRENT_WEBINARS, page, params);
export const loadUpcomingWebinarsSaga = (page, params = {}) =>
  loadWebinarsSaga(UPCOMING_WEBINARS, page, params);
export const loadPreviousWebinarsSaga = (page, params = {}) =>
  loadWebinarsSaga(PREVIOUS_WEBINARS, page, params);
export const loadUsersWebinarsSaga = (webinarType, page) => ({
  type: LOAD_USERS_WEBINARS_SAGA,
  webinarType,
  page
});

export const subscribeWebinarSaga = webinar => ({
  type: SUBSCRIBE_WEBINAR_SAGA,
  webinar
});

export const unsubscribeWebinarSaga = (id, webinarId) => ({
  type: UNSUBSCRIBE_WEBINAR_SAGA,
  id,
  webinarId
});

export const joinWebinarSaga = (
  webinarId,
  redirect = false,
  handleErrors = false
) => ({
  type: JOIN_WEBINAR_SAGA,
  webinarId,
  redirect,
  handleErrors
});

export const loadSubscriptionsSaga = () => ({
  type: LOAD_SUBSCRIPTIONS_SAGA
});

export const loadVimeoVideoDataSaga = uid => ({
  type: LOAD_VIMEO_VIDEO_DATA_SAGA,
  uid
});

export const addVimeoVideoData = (uid, videoData) => ({
  type: ADD_VIMEO_VIDEO_DATA,
  payload: {
    uid,
    data: videoData
  }
});

export const showDashboardModalSaga = (
  modal_type,
  options,
  additional = {}
) => ({
  type: SHOW_DASHBOARD_MODAL_SAGA,
  options,
  additional
});

export const updateModalData = (modalType, users, additional = {}) => ({
  type: UPDATE_MODAL_DATA,
  modalType,
  users,
  additional
});



/** WEBPACK FOOTER **
 ** ./src/actions/api.js
 **/